import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { GenerateYupValidator } from './GenYupValidator/GenerateYupValidator'
import { yupResolver } from '@hookform/resolvers/yup'
import ContentHeader from '../../../../../Layout/ContentHeader'
import { FormProvider, useForm } from 'react-hook-form'
import Box from '../../../../../Global/Box'
import InputController from '../../../../../Global/InputController'
import { useMutation, useQuery } from '@apollo/client'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import {
  CancelFields,
  ExecutionFields,
  FieldsNew,
  informFields,
  PlanificationFields,
  PlannedFields,
  SolvedFields,
  validateFields,
} from './Helper/FieldStatus'
import {
  CHANGE_REPORT_STATUS_MODAL,
  GET_ALL_RESPONSIBLES_BY_REPORT_ID,
} from '../../../../../../graphql/Catalog/Reports/reports'
import { useLoading } from '../../../../../../LoadingOverlay/LoadingOverlayContext'
import { GET_ALL_STATUS_TRANSITIONS_BY_CURRENT_STATUS } from '../../../../../../graphql/Catalog/Status/StatusTransitions'
import { objNameRoles } from '../../../../../../const/constRoles'
import moment from 'moment'
import { GET_ALL_CANCELLATION_REASON_BY_TYPE } from '../../../../../../graphql/Catalog/CancellationReason/CancellationReason'

const ModalStatus = ({
  reportFolio,
  groupCategory,
  reportData,
  user,
  currentStatus,
  currentStatusId,
  refetchMain,
  setCloseModal,
  reportId,
  start_date,
}) => {
  const { showLoading, hideLoading } = useLoading()

  //STATE
  const [fieldsSchema, setFieldsSchema] = useState({})
  const [fieldsToRender, setFieldsToRender] = useState([])
  const [statusSelected, setStatusSelected] = useState(null)
  const [optionsStatus, setOptionsStatus] = useState([])
  const [optionsReasons, setOptionsReasons] = useState([])
  const [files, setFiles] = useState([])

  const [managerGroupOptions, setManagerGroupOptions] = useState([])

  //SCHEMA
  const schema = fieldsSchema

  const {
    methods,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue,
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
  })

  const { loading, error, data } = useQuery(
    GET_ALL_STATUS_TRANSITIONS_BY_CURRENT_STATUS,
    {
      variables: {
        current_status_id: parseInt(currentStatusId),
      },
      fetchPolicy: 'no-cache',
    }
  )

  const {
    loading: loadingReasons,
    error: errorReasons,
    data: dataReasons,
  } = useQuery(GET_ALL_CANCELLATION_REASON_BY_TYPE, {
    variables: {
      type: 'reports',
      limit: null,
      offset: null,
      searchQuery: null,
    },
    fetchPolicy: 'no-cache',
  })

  const [changeStatusReport] = useMutation(CHANGE_REPORT_STATUS_MODAL)
  const [getAllResponsiblesByReportId] = useMutation(
    GET_ALL_RESPONSIBLES_BY_REPORT_ID
  )

  useEffect(() => {
    // setStatusSelected(currentStatus)
    let fields = []
    fields = GenerateYupValidator({
      fields: FieldsNew,
    })
    setFieldsSchema(fields)
    setFieldsToRender(FieldsNew)
  }, [currentStatus])

  useEffect(() => {
    // if (!statusSelected) return
    // if(statusSelected){
    //   reset()
    //   Object.keys(getValues()).forEach((key) => {
    //     setValue(key, null);
    //   });
    //   const formControls = document.querySelectorAll('.form-control-reset');
    //   formControls.forEach((control) => {
    //     control.value = null;
    //   });
    // }
    let fields = []
    let fieldsModified = []
    switch (statusSelected) {
      case 'Cancelar':
        fieldsModified = removeFieldsToArray(CancelFields, 'comments')
        fields = GenerateYupValidator({
          fields: fieldsModified,
        })
        setFieldsSchema(fields)
        setFieldsToRender(fieldsModified)
        break
      case 'Creado':
        fieldsModified = removeFieldsToArray(FieldsNew, 'comments')
        fields = GenerateYupValidator({
          fields: fieldsModified,
        })
        setFieldsSchema(fields)
        setFieldsToRender(fieldsModified)
        break
      case 'Pendiente':
        fieldsModified = removeFieldsToArray(FieldsNew, 'comments')
        fields = GenerateYupValidator({
          fields: fieldsModified,
        })
        setFieldsSchema(fields)
        setFieldsToRender(fieldsModified)
        break
      case 'En ejecución':
        fieldsModified = removeFieldsToArray(ExecutionFields, 'comments')
        fields = GenerateYupValidator({
          fields: fieldsModified,
        })
        setFieldsSchema(fields)
        setFieldsToRender(fieldsModified)
        break
      case 'Planificar':
        fieldsModified = removeFieldsToArray(PlanificationFields, 'comments')
        fields = GenerateYupValidator({
          fields: fieldsModified,
        })
        setFieldsSchema(fields)
        setFieldsToRender(fieldsModified)
        break
      case 'Planificado':
        fieldsModified = removeFieldsToArray(PlannedFields, 'comments')
        fields = GenerateYupValidator({
          fields: fieldsModified,
        })
        setFieldsSchema(fields)
        setFieldsToRender(fieldsModified)
        break
      case 'Validar ejecución':
      case 'Validar cancelación':
        fieldsModified = removeFieldsToArray(validateFields, 'comments')
        fields = GenerateYupValidator({
          fields: fieldsModified,
        })
        setFieldsSchema(fields)
        setFieldsToRender(fieldsModified)
        break
      case 'Comunicar ejecución':
      case 'Comunicar cancelación':
        fieldsModified = removeFieldsToArray(informFields, 'comments')
        fields = GenerateYupValidator({
          fields: fieldsModified,
        })
        setFieldsSchema(fields)
        setFieldsToRender(fieldsModified)
        break
      case 'Solucionado':
        fieldsModified = removeFieldsToArray(SolvedFields, 'comments')
        fields = GenerateYupValidator({
          fields: fieldsModified,
        })
        setFieldsSchema(fields)
        setFieldsToRender(fieldsModified)
        break
      case 'Citatorio':
        fieldsModified = removeFieldsToArray(informFields, 'comments')
        fields = GenerateYupValidator({
          fields: fieldsModified,
        })
        setFieldsSchema(fields)
        setFieldsToRender(fieldsModified)
        break
      case 'Multa':
        fieldsModified = removeFieldsToArray(informFields, 'comments')
        fields = GenerateYupValidator({
          fields: fieldsModified,
        })
        setFieldsSchema(fields)
        setFieldsToRender(fieldsModified)
        break
      case 'Clausura':
        fieldsModified = removeFieldsToArray(informFields, 'comments')
        fields = GenerateYupValidator({
          fields: fieldsModified,
        })
        setFieldsSchema(fields)
        setFieldsToRender(fieldsModified)
        break
      case 'Apercibimiento':
        fieldsModified = removeFieldsToArray(informFields, 'comments')
        fields = GenerateYupValidator({
          fields: fieldsModified,
        })
        setFieldsSchema(fields)
        setFieldsToRender(fieldsModified)
        break
      default:
        fields = GenerateYupValidator({
          fields: FieldsNew,
        })
        setFieldsSchema(fields)
        setFieldsToRender(FieldsNew)
        break
    }
  }, [statusSelected])

  useEffect(() => {
    if (loading) return
    if (error)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })

    const optionsNextStatus = data.getAllStatusTransitionsByCurrentStatusId.map(
      (status) => {
        const nextData = status.NextStatusData
        return {
          value: nextData.id,
          label: nextData.name,
        }
      }
    )

    setOptionsStatus(optionsNextStatus)
    // setValue('status', currentStatusId)
  }, [data, loading, error])

  useEffect(() => {
    try {
      if (loadingReasons) return
      if (errorReasons)
        return toastSweetAlert({
          mode: 'error',
          message: errorReasons.message,
        })

      const cancelReasons = dataReasons.getAllCancellationReasonByType.rows.map(
        (reason) => {
          return {
            value: reason.id,
            label: reason.reason,
          }
        }
      )

      setOptionsReasons(cancelReasons)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataReasons, loadingReasons, errorReasons])

  useEffect(() => {
    const fetchManagerGroupOptions = async () => {
      try {
        const { data } = await getAllResponsiblesByReportId({
          variables: { reportId },
        })

        const managerGroupOptions = data.getAllResponsiblesByReportId.map(
          (manager) => {
            return {
              value: manager.id,
              label: `${manager.name} (${manager?.JobPositionOfUser?.name})`,
            }
          }
        )

        setManagerGroupOptions(managerGroupOptions)
      } catch (error) {
        toastSweetAlert({
          mode: 'error',
          message: error.message,
        })
      }
    }

    // if (user?.role === objNameRoles.gestor_global_independiente) {
    //   return setManagerGroupOptions([
    //     { value: user.idUser, label: `${user.name}` },
    //   ])
    // }

    fetchManagerGroupOptions()
  }, [user, reportId, getAllResponsiblesByReportId])

  const handleDrop = (e) => {
    e.preventDefault()
    if (files.length >= 5 || e.dataTransfer.files.length > 5)
      return toastSweetAlert({
        mode: 'error',
        message: 'Solo puedes subir 5 archivos',
      })

    //Validate files
    for (let i = 0; i < e.dataTransfer.files.length; i++) {
      const file = e.dataTransfer.files[i]

      const getType = file.type.split('/')[1]

      const allowedTypes = ['png', 'jpeg', 'jpg', 'pdf']

      if (!allowedTypes.includes(getType)) {
        return toastSweetAlert({
          mode: 'error',
          message: 'Este tipo de archivo no esta permitido',
        })
      }

      const allowedSize = 1024 * 1024 * 5

      if (file.size > allowedSize) {
        return toastSweetAlert({
          mode: 'error',
          message: 'El archivo es muy grande',
        })
      }
    }

    const newFiles = [...e.dataTransfer.files]
    setFiles((prevFiles) => [
      ...prevFiles,
      ...newFiles.slice(0, 5 - prevFiles.length),
    ])
  }
  const handleDragOver = (e) => {
    e.preventDefault()
  }

  const handleRemoveFile = (index) => {
    const newFiles = files.filter((file, i) => i !== index)
    setFiles(newFiles)
  }

  const resetForm = () => {}

  const removeFieldsToArray = (array, field) => {
    if (reportData && reportData.channel_capture === 'app') return array

    const indexFieldComments = array.filter(
      (fieldArray) => fieldArray.name !== field
    )
    return indexFieldComments
  }

  const onSubmit = async (data) => {
    showLoading()
    try {
      let input = {
        reportId: +reportData.id,
        statusIdNext: +data.status,
        planning_date: data.planning_date,
        comments_internal: data?.comments_internal ?? null,
        comments: data?.comments ?? null,
        cancel_reason: +data.cancel_reason,
        attatchments: files,
      }

      if (
        (data.status == '4' && !data.manager_group) ||
        (data.status == '2' && !data.manager_group)
      ) {
        hideLoading()
        return toastSweetAlert({
          mode: 'error',
          message: 'Debe seleccionar un responsable',
        })
      }

      //Validate if status is 2 = planificar we need to validate date
      if (data.status == '2') {
        if (!reportData?.start_date) {
          hideLoading()
          return toastSweetAlert({
            mode: 'error',
            message: 'No se puede planificar un reporte sin fecha de creación',
          })
        }

        if (
          moment(data.planning_date).isBefore(
            moment(reportData?.start_date),
            'day'
          )
        ) {
          hideLoading()
          return toastSweetAlert({
            mode: 'error',
            message: `La fecha de planificación no puede ser anterior al día de la creación del reporte ${moment(
              reportData?.start_date
            ).format('DD/MM/YYYY')}`,
          })
        }
        if (moment(data.planning_date).isBefore(moment(), 'day')) {
          hideLoading()
          return toastSweetAlert({
            mode: 'error',
            message:
              'La fecha de planificación no puede ser anterior a la fecha actual',
          })
        }
      }

      // if (data?.manager_group && data.status == '4')
      if (data?.manager_group)
        input.responsible_id = parseInt(data.manager_group)

      const { data: response } = await changeStatusReport({
        variables: {
          input,
        },
      })

      if (response.changeReportStatusV2) {
        await refetchMain()
        setFiles([])
        reset()
        setStatusSelected(null)
        setFieldsSchema({})
        setFieldsToRender([])
        setCloseModal(true)
        toastSweetAlert({
          mode: 'ok',
          message: 'Estado cambiado correctamente',
        })
      }
      hideLoading()
    } catch (error) {
      hideLoading()
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }
  return (
    <div className="modal-status-box">
      {/* <ContentHeader /> */}

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            withCard={false}
            btnSubmit
            // btnSecondFunction={}
            // btnSecondFunctionTitle="Cancelar"
            st
            content={
              <>
                <div
                  className="row modal-status-box-content"
                >
                  <div className="col-12 modal-status-box-header">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2">
                        <span className="title-details">Reporte</span>
                        <br />
                        <span className="content-details">{reportFolio}</span>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2">
                        <span className="title-details">Estado actual</span>
                        <br />
                        <span className="content-details">{currentStatus}</span>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2">
                        <span className="title-details">Categoría</span>
                        <br />
                        <span className="content-details">{groupCategory}</span>
                      </div>
                    </div>
                  </div>
                  {fieldsToRender &&
                    fieldsToRender.length > 0 &&
                    fieldsToRender.map((field, index) => {
                      return (
                        <>
                          {field.name === 'status' ? (
                            <div className={`col-12 p-2`}>
                              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <InputController
                                  name={field.name}
                                  control={control}
                                  label={field.label}
                                  inputType={field.inputType}
                                  options={optionsStatus}
                                  menuPosition="fixed"
                                  placeholderTxt="Selecciona un estado"
                                  changeAction={(e) =>
                                    setStatusSelected(e.label)
                                  }
                                />
                              </div>
                            </div>
                          ) : field.inputType === 'choosen' ? (
                            <div className={`col-12 p-2`}>
                              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <InputController
                                  addClass="form-control-reset"
                                  name={field.name}
                                  control={control}
                                  label={field.label}
                                  inputType={field.inputType}
                                  placeholderTxt={`Selecciona un ${field.label}`}
                                  options={
                                    field.name === 'manager_group'
                                      ? managerGroupOptions
                                      : optionsReasons
                                  }
                                  menuPosition="fixed"
                                  changeAction={() => {}}
                                />
                              </div>
                            </div>
                          ) : field.inputType === 'date' ? (
                            <div className={`col-12 p-2`}>
                              <div
                                className={`col-sm-${field.colSize} col-md-${field.colSize}`}
                              >
                                <InputController
                                  addClass="form-control-reset"
                                  name={field.name}
                                  control={control}
                                  label={field.label}
                                  // inputType={field.inputType}
                                  type={field.inputType}
                                />
                              </div>
                            </div>
                          ) : field.inputType === 'textarea' ? (
                            <div className={`col-12 p-2`}>
                              <div
                                className={`col-sm-${field.colSize} col-md-${field.colSize} col-lg-${field.colSize}`}
                              >
                                <InputController
                                  addClass="form-control-reset"
                                  placeholderTxt={`${field.label} ${
                                    field.label === 'Comentario' ? 'Global' : ''
                                  }`}
                                  name={field.name}
                                  control={control}
                                  label={`${field.label} (${
                                    field.label == 'Comentario Interno'
                                      ? 'Privado'
                                      : field.label == 'Comentario'
                                      ? 'Global'
                                      : ''
                                  })`}
                                  inputType={field.inputType}
                                />
                              </div>
                            </div>
                          ) : (
                            field.inputType === 'attachments' && (
                              <div
                                className="col-12"
                                style={{ padding: '20px' }}
                              >
                                <div
                                  className="d-flex justify-content-between"
                                  style={{
                                    fontFamily: 'InterRegular',
                                  }}
                                >
                                  <label>Archivos adjuntos</label>
                                  <label>{files.length}/5</label>
                                </div>

                                {/* Área de arrastrar y soltar */}
                                <div
                                  className="col-12"
                                  style={{
                                    border: '2px dashed #ccc',
                                    padding: '20px',
                                    textAlign: 'center',
                                    borderRadius: '10px', // Bordes redondeados
                                    backgroundColor: '#f9f9f9', // Fondo claro
                                  }}
                                  onDrop={handleDrop}
                                  onDragOver={handleDragOver}
                                  accept
                                >
                                  <div
                                    style={{
                                      color: '#F97316',
                                    }}
                                  >
                                    <i class="fas fa-camera fa-lg"></i>
                                    <p
                                    // style={{
                                    //   fontSize: '24px',
                                    //   margin: '0',
                                    //   fontWeight: 'bold',
                                    // }}
                                    >
                                      Arrastra y suelta archivos aquí
                                    </p>
                                    {/* Vista previa de archivos subidos */}
                                    {files.length > 0 && (
                                      <div style={{ marginTop: '20px' }}>
                                        <h4>Archivos subidos:</h4>
                                        <div
                                          style={{
                                            display: 'flex',
                                            flexWrap: 'nowrap',
                                            // gap: '10px',
                                          }}
                                        >
                                          {files.map((file, index) => (
                                            <div
                                              key={index}
                                              style={{
                                                textAlign: 'center',
                                                position: 'relative',
                                                gap: '5px',
                                                border: '1px solid #ccc',
                                                borderRadius: '5px',
                                              }}
                                            >
                                              <button
                                                onClick={() =>
                                                  handleRemoveFile(index)
                                                }
                                                style={{
                                                  position: 'absolute',
                                                  top: '5px',
                                                  right: '5px',
                                                  background: '#ff4d4d',
                                                  color: '#fff',
                                                  border: 'none',
                                                  borderRadius: '50%',
                                                  width: '24px',
                                                  height: '24px',
                                                  cursor: 'pointer',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  fontSize: '12px',
                                                }}
                                              >
                                                ×
                                              </button>

                                              {file.type.split('/')[0] ===
                                              'image' ? (
                                                <img
                                                  src={URL.createObjectURL(
                                                    file
                                                  )} // Muestra la vista previa
                                                  alt={file.name}
                                                  style={{
                                                    width: '50px',
                                                    height: '50px',
                                                    objectFit: 'cover',
                                                    borderRadius: '5px',
                                                  }}
                                                />
                                              ) : (
                                                <span
                                                  style={{
                                                    fontSize: '40px',
                                                    color: '#ff4d4d',
                                                  }}
                                                >
                                                  {' '}
                                                  <i
                                                    className={`far fa-file-${
                                                      file.type.split('/')[1]
                                                    }`}
                                                  ></i>
                                                </span>
                                              )}
                                              <p
                                                style={{
                                                  // margin: '5px 0',
                                                  fontSize: '12px',
                                                  wordBreak: 'break-all',
                                                }}
                                              >
                                                {file.name}
                                              </p>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  {/* Texto de formatos y límite de archivos */}
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginTop: '10px',
                                      fontSize: '14px',
                                      color: '#666',
                                    }}
                                  >
                                    <p>
                                      Formatos permitidos: .png, .jpeg, .jpg y
                                      .pdf - Tamaño máximo: 5MB
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                        </>
                      )
                    })}
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </div>
  )
}

export default ModalStatus
